import { Component, Input, ViewChildren, ViewContainerRef, QueryList, } from '@angular/core';
import { DocumentMetadata } from 'app/fs/res/common/model/documents/documentMetadata';
import { HisBaseGlobalsService } from 'hisng';

import { DYNAMIC_FIELDSET_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { Publication } from 'app/fs/res/publication/model/publication';

@Component( {
    selector: 'res-publication-documents-tab',
    templateUrl: './publication-documents-tab.component.html',
    providers: [ProviderManager.getComponentProvider(PublicationDocumentsTabComponent)],
} )
export class PublicationDocumentsTabComponent {
    @Input() publication: Publication;
    @Input() documentsToSave: DocumentMetadata[];
    @ViewChildren( DYNAMIC_FIELDSET_ANCHOR, { read: ViewContainerRef } )
        fieldsetViewContainerList: QueryList<ViewContainerRef>;

    constructor(public hisBaseGlobalsService: HisBaseGlobalsService) {}

    public isContactPanelVisible() {
        let dDEntryPublicationCreator = this.hisBaseGlobalsService.getDd('fs.res.publication.PublicationContact.publicationCreator');
        return !dDEntryPublicationCreator?.hidden;
    }

    public isHidden( ddKey: string ) {
        return this.hisBaseGlobalsService.getDd(ddKey)?.hidden;
    }
}
